/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import feedbackEndpoints from '../feedback'



const authBasePath = '/membership/payments'

const paymentsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  fetchPayments: builder.query<any, {pageNumber: number}>({
    query: ({pageNumber}) => ({
      url: `${authBasePath}?size=10&page=${pageNumber}`,
      method: 'get',
    }),
  }),

  fetchRevenueReport: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${authBasePath}/revenue?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
  }),

  fetchRevenueCustomers: builder.query<any, { startDate: string; endDate: string }>({
    query: ({ startDate, endDate }) => ({
      url: `${authBasePath}/revenue/customers?startDate=${startDate}&endDate=${endDate}`,
      method: 'get',
    }),
  }),
})

export default paymentsEndpoints



